import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const EditorComponent = ({editorContent , setEditorContent}) => {
    return (
        <CKEditor
            editor={ClassicEditor}
            data={editorContent}
            config={{
                allowedContent: true,
                toolbar: {
                    items: [
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "Underline",
                        "Superscript",
                        "Subscript",
                        "Strikethrough",
                        "fontSize",
                        "fontColor",
                        "fontBackgroundColor",
                        "bulletedList",
                        "numberedList",
                        "|",
                        "indent",
                        "outdent",
                        "|",
                        "blockQuote",
                        "insertTable",
                        "|",
                        "undo",
                        "redo",
                        "mediaEmbed",
                        "imageUpload",
                        "link",
                        "fontFamily",
                        "alignment",
                    ],
                },
                mediaEmbed: {
                    previewsInData: true,
                },
                image: {
                    toolbar: [
                        "imageTextAlternative",
                        "|",
                        "imageStyle:full",
                        "imageStyle:side",
                    ],
                    styles: ["alignLeft", "alignCenter", "alignRight"],
                },
                fontFamily: {
                    options: ["Helvetica", "Open Sans"],
                },
            }}
            onChange={(event, editor) => {
                setEditorContent(editor.getData());
            }}
        />
    )
}

export default EditorComponent;